import Vue from 'vue'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userStatus']),
    checkBadgeColor() {
      if (this.userStatus == 1) {
        return Vue.config.modules.crm.staticData.employerActivityStatuses[0].color
      }
      return Vue.config.modules.crm.staticData.employerActivityStatuses[1].color
    },
  },
}
